<div class="advert-action crm-scroll">
  <div class="advert-action-wrapper">
    <ng-container *ngTemplateOutlet="titleTemplate" />
    <ng-container *ngTemplateOutlet="formTemplate" />
    <ng-container *ngTemplateOutlet="actionsTemplate" />
    <ng-container *ngTemplateOutlet="loaderTemplate" />
  </div>
</div>

<ng-template #titleTemplate>
  <div class="advert-action-title-container">
    <span class="advert-action-title">
      {{ (actionType === AdvertActionType.Create ? 'create_advert' : 'change_advert') | translate }}
    </span>
    @if (baseService.isMobile) {
      <app-button (onChangeClick)="onCloseSidebar()"
                  btnType="icon">
        <app-icon>close</app-icon>
      </app-button>
    }
  </div>
</ng-template>

<ng-template #formTemplate>
  <div [formGroup]="advertForm" class="advert-action-form">
    <mat-card class="advert-action-form-card">
      <span class="advert-action-form-card-title">{{ 'describe_in_detail' | translate }}</span>
      <app-text-field type="v2"
                      label="title"
                      [maxLength]="150"
                      placeholder="power_olx_title_placeholder"
                      [formControl]="advertForm.controls.title" />
<!--      <app-textarea label="description"-->
<!--                    [maxLength]="9000"-->
<!--                    [placeholder]="'power_olx_description_placeholder' | translate"-->
<!--                    [formControl]="advertForm.controls.description" />-->
      <app-input labelType="floating" [inputType]="'editor'" [formControl]="advertForm.controls.description" />

      <div class="advert-action-description-actions">
        <app-button btnType="stroked"
                    [disabled]="loaders.description"
                    (onChangeClick)="onGenerateDescription()">
          <div class="d-flex align-items-center">
            <app-icon>auto_awesome</app-icon>
            {{ 'generate_advert_description' | translate }}
          </div>
        </app-button>
        <span class="advert-action-description-hint">
          {{ 'ai_generate' | translate }}
        </span>
      </div>

      <app-advert-category-picker [categories]="categories"
                                  [categoryControl]="advertForm.controls.category_id"
                                  (categoryChanged)="onCategoryChanged($event)"
                                  [loader]="loaders.categories"
                                  [isCanPick]="actionType === AdvertActionType.Create
                                                || (actionType === AdvertActionType.Update && !!plannerId)" />
    </mat-card>

    @if (selectedCategory?.photos_limit) {
      <mat-card class="advert-action-form-card">
        <span class="advert-action-form-card-title">{{ 'photo' | translate }}</span>
        <app-group-images-picker [imagesControl]="advertForm.controls.images"
                                 [photosLimit]="selectedCategory!.photos_limit" />
      </mat-card>
    }

    @if (selectedPriceAttribute) {
      <mat-card class="advert-action-form-card">
        <span class="advert-action-form-card-title">{{ 'price' | translate }}</span>
        <app-price-editor [price]="draft?.advert?.price || advert?.price"
                          [priceAttribute]="selectedPriceAttribute"
                          (formReady)="onPriceFormReady($event)"/>
      </mat-card>
    }

    @if (selectedSalaryAttribute) {
      <mat-card class="advert-action-form-card">
        <span class="advert-action-form-card-title">{{ 'salary' | translate }}</span>
        <app-button class="d-flex flex-column"
                    [dev]="true"
                    [disabled]="true">
          {{ 'salary' | translate }}
        </app-button>
        <!--      <app-salary-editor [salary]="this.advert?.salary"-->
        <!--                         (formReady)="onSalaryFormReady($event)" />-->
      </mat-card>
    }

    <mat-card class="advert-action-form-card">
      <app-toggle [formControl]="advertForm.controls.auto_extend_enabled"  >
        <span class="advert-action-form-card-title">
          {{'auto_extend' | translate}}
        </span>
      </app-toggle>
    </mat-card>

    <mat-card class="advert-action-form-card">
      <span class="advert-action-form-card-title">{{ 'your_contact_details' | translate }}</span>
      <app-olx-location-dropdown [locations]="cities"
                                 [loading]="loaders.cities"
                                 (onSearchDropdown)="searchCity($event)"
                                 [formControl]="advertForm.controls.location"
                                 [selectedLocation]="selectedLocation"
                                 (locationChanged)="onLocationChanged($event)" />
      <app-text-field type="v2"
                      label="contact_name"
                      [formControl]="advertForm.controls.contact.controls.name" />
      <app-text-field type="v2"
                      label="phone"
                      placeholder="+380"
                      [isPlaceholderTranslate]="false"
                      [formControl]="advertForm.controls.contact.controls.phone" />
    </mat-card>

    @if (selectedCategoryAttributes) {
      <mat-card class="advert-action-form-card">
        <span class="advert-action-form-card-title">{{ 'additional_information' | translate }}</span>
        <div class="advert-action-form-card-content">
          <app-button-toggle-group [control]="advertForm.controls.advertiser_type"
                                   [values]="advertiserTypeValues"
                                   label="private_or_business"
                                   [isRequired]="true"
                                   [isError]="advertForm.controls.advertiser_type.invalid
                                              && advertForm.controls.advertiser_type.touched"
                                   (focusout)="advertForm.controls.advertiser_type.markAsTouched()" />
          <app-advert-attributes-editor [advertForm]="advertForm"
                                        [attributes]="selectedCategoryAttributes"
                                        [existingValues]="draft?.advert?.attributes || advert?.attributes"  />
        </div>
      </mat-card>
    }
  </div>
</ng-template>

<ng-template #actionsTemplate>
  <div class="advert-action-actions-container">
    <mat-card class="advert-action-actions">
      <app-button btnType="cancel" (onChangeClick)="onCancel()">
        {{ 'cancel' | translate }}
      </app-button>
      <div class="advert-action-actions-save-container">
        @if (actionType === AdvertActionType.Create) {
          <app-button btnType="icon"
                      [disabled]="!!selectedSalaryAttribute"
                      [dev]="!!selectedSalaryAttribute"
                      [matTooltip]="'plan_now' | translate"
                      (onChangeClick)="onOpenPlanner()">
            <app-icon>calendar_month</app-icon>
          </app-button>
        }
        <app-button [disabled]="!!selectedSalaryAttribute"
                    [dev]="!!selectedSalaryAttribute"
                    (onChangeClick)="onSave()">
          {{ (actionType === AdvertActionType.Create ? 'create_now' : 'update') | translate }}
        </app-button>
      </div>
    </mat-card>
  </div>
</ng-template>

<ng-template #loaderTemplate>
  @if (loaders.action) {
    <ngx-skeleton-loader class="skeleton-overlay"
                         animation="pulse"
                         [theme]="{ width: '100%', height: '100%' }" />
  }
</ng-template>
